import { Button, Form, Input, Modal } from "antd";

const CreateEditEducatorModal = ({
  isModalOpen = false,
  isEdit = false,
  setIsEdit = () => {},
  setInitialValues = () => {},
  setIsModalOpen = () => {},
  initialValues = {},
  handleCreateEdit = () => {}
}) => {
  const [form] = Form.useForm();
  return (
    <Modal
      title="Create/Edit Educator"
      centered
      open={isModalOpen}
      footer={[]}
      onOk={() => {
        setIsModalOpen(false);
        setIsEdit(false);
        setInitialValues({});
      }}
      onCancel={() => {
        setIsModalOpen(false);
        setIsEdit(false);
        setInitialValues({});
      }}
    >
      <Form
        form={form}
        initialValues={isEdit ? initialValues : {}}
        name="new_educator_form"
        onFinish={handleCreateEdit}
      >
        <Form.Item
          name="name"
          label="Name"
          rules={[
            {
              required: true,
              message: "Please enter the Educator's name!"
            }
          ]}
        >
          <Input prefix={<i className="fa fa-ship" aria-hidden="true" />} placeholder="John Doe" />
        </Form.Item>

        <Form.Item
          name="email"
          label="Email"
          rules={[
            {
              required: true,
              message: "Please enter the Educator's email!"
            }
          ]}
        >
          <Input
            prefix={<i className="fa fa-ship" aria-hidden="true" />}
            placeholder="john@doe.com"
          />
        </Form.Item>

        <Form.Item
          name="contactNumber"
          label="Contact Number"
          rules={[
            {
              required: true,
              message: "Please enter the Educator's number!"
            }
          ]}
        >
          <Input
            prefix={<i className="fa fa-ship" aria-hidden="true" />}
            placeholder="+91 XXXXXXXXXX"
          />
        </Form.Item>

        <Form.Item className="submit-btn">
          <Button type="primary" htmlType="submit">
            {isEdit === true ? "Update" : "Create"} Educator
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default CreateEditEducatorModal;
